<template>
    <div>
        <div v-for="cate in data" :key="cate.name">
            <div class="weui-cells__title">{{cate.name}}</div>
            <div class="weui-cells">
                <router-link :to="getRoute(item.id, item.route, item.status_value)" class="weui-cell weui-cell_access" v-for="item in cate.items" :key="item.id">
                    <div class="weui-cell__hd">
                        <img :src="item.cover" style="width: 44px">
                    </div>
                    <div class="weui-cell__bd">
                        <p class="weui-media-box__title">&nbsp;{{item.title}}</p>
                        <p class="weui-media-box__desc">&nbsp;&nbsp;{{item.excerpt}}</p>
                    </div>
                    <div class="weui-cell__ft">{{item.status}}</div>
                </router-link>
            </div>
        </div>

        <div class="weui-cells__title">其他</div>
        <div class="weui-cells">
            <external-link class="weui-cell weui-cell_access"
                :to="link.url" :key="link.url" v-for="link in links" >
                <div class="weui-cell__bd">
                    <p class="weui-media-box__title">{{link.title}}</p>
                </div>
                <div class="weui-cell__ft"></div>
            </external-link>
        </div>
    </div>
</template>

<script>
import ExternalLink from "@/components/ExternalLink";

export default {
    name: "ServiceNavMember",
    data: function() {
        return {
            data: [],
            links: []
        };
    },
    created () {
        // 组件创建完后获取数据，
        // 此时 data 已经被 observed 了
        this.fetchData()
    },
    watch: {
        // 如果路由有变化，会再次执行该方法
        '$route': 'fetchData'
    },
    methods: {
        fetchData: function() {
            this.$store.commit('loading');
            this.$axios.get("service", {
                params: {
                    level: 1
                }
            }).then(response => {
                this.data = response.data.items;
                this.links = response.data.links;

                this.$store.commit('loading', false);
            });
        },
        getRoute(id, route, status) {
            return status == 'onsale' ? {
                path: `/service/${id}${route}` 
            } : {
                path: `/service/${id}`
            };
        }
    },
    components: {
        ExternalLink
    }
};
</script>
